import { render, staticRenderFns } from "./FeedManagerNotifications.vue?vue&type=template&id=562b40a9&scoped=true&"
import script from "./FeedManagerNotifications.vue?vue&type=script&lang=js&"
export * from "./FeedManagerNotifications.vue?vue&type=script&lang=js&"
import style0 from "./FeedManagerNotifications.vue?vue&type=style&index=0&id=562b40a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562b40a9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/harness/feed-manager-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('562b40a9')) {
      api.createRecord('562b40a9', component.options)
    } else {
      api.reload('562b40a9', component.options)
    }
    module.hot.accept("./FeedManagerNotifications.vue?vue&type=template&id=562b40a9&scoped=true&", function () {
      api.rerender('562b40a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FeedManagerNotifications.vue"
export default component.exports